import { scrollToTop } from '@/shared/utils/tools';
import React, { useEffect, useState } from 'react';
import Image from 'next/image';
import classNames from 'classnames';
import './index.less';

export interface IProps {
  visible: boolean;
  className?: string;
  style?: any;
  close: () => void;
  hideCloseButton?: boolean;
  maskIsNotClosable?: boolean;
  children: JSX.Element;
}

const PietraModal = ({ visible, className, style, close, hideCloseButton, maskIsNotClosable, children }: IProps) => {
  const [isClick, setIsClick] = useState<boolean>(false);

  useEffect(() => {
    scrollToTop(`.${className} .dialog-inner`);
  }, [className, visible]);

  const onDialogClick = () => {
    if (maskIsNotClosable) {
      return;
    }

    if (isClick) {
      setIsClick(false);
    } else {
      close();
    }
  };

  if (!visible) {
    return null;
  }

  return (
    <div className={classNames('pietra-dialog', { [className]: className, show: visible })} onClick={onDialogClick}>
      <div
        className={'dialog-inner ' + (visible ? 'show' : '')}
        style={style}
        onMouseUp={() => {
          setIsClick(false);
        }}
        onMouseDown={() => {
          setIsClick(true);
        }}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        {!hideCloseButton && (
          <Image className="exit" src="/images/close.png" width={25} height={25} alt="close" onClick={close} />
        )}
        {children}
      </div>
    </div>
  );
};

export default PietraModal;
